import { FilterMatchMode } from "primereact/api"

export class Comunicacion {
    model = {
        id: { value: null, export: false },
        idp: { value: null, export: false },
        emisor: {
            header: 'Emisor (Quién)',
            value: null,
            required: 'Selecione una opción',
            optionLabel: 'nombre',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'emisor',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        mensaje: {
            header: 'Mensaje',
            value: null,
            required: 'Selecione una opción',
            optionLabel: 'nombre',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'mensaje',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        correo: {
            header: 'Canal',
            value: null,
            required: 'Selecione una opcion',
            optionLabel: 'correo',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'correo',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        cuando: {
            header: 'Cuándo',
            value: null,
            required: 'Selecione una opcion',
            optionLabel: 'cuando',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'cuando',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        receptor: {
            header: 'Receptor',
            value: null,
            required: 'Selecione una opcion',
            optionLabel: 'receptor',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'receptor',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        }
    }
}
